var borders_default = {
  "borderT": "UgZe4",
  "borderB": "S828P",
  "borderL": "Wjuq7",
  "borderR": "MTFAi",
  "borderColorOverride": "jOb56"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
